declare var saveAs: any;

module EEX.McEc.Controls.CertificateDialog {

    import Forms = AppKitchen.Controls.Forms;
    import TextPool = AppKitchen.Controls.Forms.TextPool;

    // ReSharper disable once InconsistentNaming
    export interface SetServerCertificateAttribtuesAttribute extends CertificateDialogBaseAttribute {
        server: string,
        country: string,
        state?: string,
        locality: string,
        organization: string,
        organizationalUnit?: string,
    }

    export class SetServerCertificateAttribtuesModel extends CertificateDialogBaseModel<SetServerCertificateAttribtuesAttribute> {

        constructor(model: CertificateDialogModel, processStep: number) {
            super(model, processStep,
                {
                    server: "",
                    country: "",
                    locality: "",
                    organization: "",
                });

            this.on("change", this.updateDialogModel);
        }

        public updateDialogModel() {
            if (this.isNotNullOrEmpty(this.get().server)
                && this.isNotNullOrEmpty(this.get().country)
                && this.isNotNullOrEmpty(this.get().locality)
                && this.isNotNullOrEmpty(this.get().organization)) {
                this.model.set({
                    certificateAttributes: {
                        commonName: this.get().server,
                        countryName: this.get().country,
                        localityName: this.get().locality,
                        organizationName: this.get().organization,
                        stateName: this.get().state,
                        organizationalUnitName: this.get().organizationalUnit,
                    }
                });
                this.canContinue();
            } else {
                this.canNotContinue();
            }
        }

        private isNotNullOrEmpty(value: string) {
            return value && value !== "";
        }
    }

    // ReSharper disable once InconsistentNaming
    export interface SetServerCertificateAttribtuesOptions extends CertificateDialogBaseOptions {
    }

    export class SetServerCertificateAttributesView extends CertificateDialogBaseView<SetServerCertificateAttribtuesModel> {
        model: SetServerCertificateAttribtuesModel;

        private formModel: AppKitchen.Controls.Forms.FormModel;

        private containers: {
            form: HTMLElement,
        }

        constructor(model: SetServerCertificateAttribtuesModel, target: HTMLElement, options?: SetServerCertificateAttribtuesOptions) {
            super(model,
                target,
                McEc.Templates.CertificateDialog_SetServerCertificateAttributes,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: McEc.Strings.CertificateDialog_SetServerCertificateAttributes_Title
                    }));

                    
            this.loadConutryCodePool((countryCodePool: TextPool) => {
                this.initForm(countryCodePool);
            });
        }

        private initForm(countryCodePool: TextPool): void {
            var fields = [
                new Forms.FieldModel("server",
                    Forms.FieldType.Text,
                    McEc.Strings.CertificateDialog_SetServerCertificateAttributes_Server,
                    { mandatory: true }),
                new Forms.FieldModel("country",
                    Forms.FieldType.Text,
                    McEc.Strings.CertificateDialog_SetServerCertificateAttributes_Country,
                    { mandatory: true, pool: countryCodePool }),
                new Forms.FieldModel("state",
                    Forms.FieldType.Text,
                    McEc.Strings.CertificateDialog_SetServerCertificateAttributes_State,
                    { mandatory: false }),
                new Forms.FieldModel("locality",
                    Forms.FieldType.Text,
                    McEc.Strings.CertificateDialog_SetServerCertificateAttributes_Locality,
                    { mandatory: true }),
                new Forms.FieldModel("organization",
                    Forms.FieldType.Text,
                    McEc.Strings.CertificateDialog_SetServerCertificateAttributes_Organization,
                    { mandatory: true }),
                new Forms.FieldModel("organizationalUnit",
                    Forms.FieldType.Text,
                    McEc.Strings.CertificateDialog_SetServerCertificateAttributes_OrganizationalUnit,
                    { mandatory: false })
            ];
            this.formModel = new AppKitchen.Controls.Forms.FormModel(fields);

            this.formModel.setFieldsData({
                country: "DE"
            });

            this.formModel.onAnyValueChange(this.changedAttributes.bind(this));
        }

        private loadConutryCodePool(success: (textPool: TextPool) => void): void {
            AppKitchen.Data.getDocument("Data",
                "McEc/CountryCodes",
                doc => {
                    let config = JSON.parse(doc);
                    let pool = this.createTextPool(config);
                    success(pool);
                });
        }

        private createTextPool(poolConfig: any): TextPool {
            let countryCodePool: TextPool = {
                values: poolConfig,
                textField: "Name",
                valueField: "Code",
                restrict: true
            };
            return countryCodePool;
        }

        render() {
            super.render();
            this.setContainers();
            this.createForm();
            return this;
        }

        private setContainers(): void {
            this.containers = {
                form: this.$el.find(".set-server-certificate-atributes-form-container")[0]
            }
        }

        private changedAttributes(): void {
            const server = this.formModel.getValue("server");
            const country = this.formModel.getValue("country");
            const state = this.formModel.getValue("state");
            const locality = this.formModel.getValue("locality");
            const organization = this.formModel.getValue("organization");
            const organizationalUnit = this.formModel.getValue("organizationalUnit");

            this.model.set({ 
                server: server,
                country: country,
                state: state,
                locality: locality,
                organization: organization,
                organizationalUnit: organizationalUnit,
            });
        }

        private createForm(): void {
            // ReSharper disable once WrongExpressionStatement
            new AppKitchen.Controls.Forms.TemplatedFormView(this.formModel, this.containers.form, McEc.Templates.ServerServerCertificateAttributesForm,
                { editable: true });
        }
    }
}